import React from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import '@progress/kendo-theme-fluent/dist/all.css';
import { FaPlusCircle } from 'react-icons/fa';
import { Group } from '../../data/groupData';

interface GroupsGridProps {
  data: Group[];
  onAdd?: () => void;
  onEdit?: (group: Group) => void;
}

function GroupsGrid({ data, onAdd, onEdit }: GroupsGridProps) {
  const handleRowClick = (event: any) => {
    if (onEdit) {
      onEdit(event.dataItem);
    }
  };

  return (
    <div className="jobs-kendo-fluent-theme">
      {/* Header */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginBottom: '24px',
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
        border: '1px solid #edebe9'
      }}>
        <h2 style={{ 
          fontSize: '1.25rem', 
          fontWeight: '600',
          margin: 0,
          color: '#323130'
        }}>
          Groups Management
        </h2>
      </div>

      {/* Action Buttons */}
      {onAdd && (
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          marginBottom: "1rem"
        }}>
          <div style={{ display: "flex", gap: "1rem" }}>
            <Button
              themeColor="primary"
              onClick={onAdd}
            >
              <FaPlusCircle style={{ marginRight: "0.5rem" }} />
              Add New Group
            </Button>
          </div>
        </div>
      )}

      {/* Kendo Grid */}
      <Grid
        data={data}
        pageable={{
          buttonCount: 5,
          info: true,
          type: 'numeric',
          pageSizes: [10, 25, 50, 100],
          previousNext: true
        }}
        sortable={true}
        filterable={true}
        resizable={true}
        reorderable={true}
        style={{ 
          height: '600px',
          cursor: onEdit ? 'pointer' : 'default'
        }}
        onRowClick={handleRowClick}
      >
        <GridColumn 
          field="name" 
          title="Group Name" 
          width="250px"
          filterable={true}
          sortable={true}
        />
        
        <GridColumn 
          field="groupType" 
          title="Type" 
          width="130px"
          filterable={true}
          sortable={true}
        />
        
        <GridColumn 
          field="description" 
          title="Description" 
          width="350px"
          filterable={true}
          sortable={true}
        />
        
        <GridColumn 
          field="employees.length" 
          title="Employees" 
          width="120px"
          filterable={true}
          sortable={true}
          cell={({ dataItem }) => (
            <td style={{ textAlign: 'center' }}>{dataItem.employees?.length || 0}</td>
          )}
        />
        
        <GridColumn 
          field="roles.length" 
          title="Roles" 
          width="120px"
          filterable={true}
          sortable={true}
          cell={({ dataItem }) => (
            <td style={{ textAlign: 'center' }}>{dataItem.roles?.length || 0}</td>
          )}
        />
      </Grid>

      {/* Summary */}
      <div style={{ 
        marginTop: '24px', 
        padding: '16px', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '2px',
        border: '1px solid #edebe9',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ 
          fontSize: '14px',
          fontWeight: '600',
          color: '#323130'
        }}>
          Total Groups: <span style={{ color: '#0078d4' }}>{data.length}</span>
        </div>
      </div>
    </div>
  );
}

export default GroupsGrid;
